/**
 * Convert the Properties from entry content into an array of objects to be used in different components
 *
 * @param data
 * @returns {[]}
 */

const getAgeNumber = (title) => Number(title.replace(/\D/g, ''))

export default function getExercisePropertyData(entry, t, type, customDuration) {
  const data = []

  const fieldSizeEntryType = type === 'exerciseDetail' ? entry.exerciseContent?.[0] : entry
  const playerCountEntryType = type === 'exerciseDetail' ? entry.exerciseContent?.[0] : entry
  const ageEntryType = entry
  const durationEntryType = type === 'exerciseDetail' ? entry.exerciseContent?.[0] : entry
  const frequencyEntryType = entry

  if (!entry) return null
  if (fieldSizeEntryType?.fieldSizeCategory) {
    let label = false
    if (fieldSizeEntryType.fieldSizeCategory[0]) {
      label = fieldSizeEntryType.fieldSizeCategory[0].title
      if (fieldSizeEntryType?.fieldTypeCategory?.[0]?.title === 'indoor' && label) {
        label = label.replace(t('PROPERTYBLOCK__OUTDOOR'), t('PROPERTYBLOCK__INDOOR'))
      }
    }

    if (label !== false) {
      data.push({
        icon: 'pylon',
        label
      })
    }
  }

  if (playerCountEntryType?.playersMinimum || playerCountEntryType?.playersMaximum) {
    const suffix = type && type === 'detailCard' ? '' : ` ${t('PROPERTYBLOCK__PLAYERS')}`
    data.push({
      icon: 'user',
      label: `${playerCountEntryType.playersMinimum} - ${playerCountEntryType.playersMaximum}${suffix}`
    })
  }

  if (ageEntryType.ageCategories) {
    const filteredAgeCategories = ageEntryType.ageCategories.filter((category) => {
      return category.level === 2
    })

    const sortedAgeCategories = filteredAgeCategories.sort((a, b) => {
      if (getAgeNumber(a.title) !== 0 && getAgeNumber(b.title) !== 0) {
        return getAgeNumber(a.title) - getAgeNumber(b.title)
      } else {
        return getAgeNumber(b.title) - getAgeNumber(a.title)
      }
    })

    const labelsArray = sortedAgeCategories.map((o, index) => {
      let hideTitle = false
      let hideAbbr = false
      if (getAgeNumber(o.title) !== 0) {
        if (sortedAgeCategories[index - 1] && sortedAgeCategories[index + 1]) {
          hideTitle =
            getAgeNumber(sortedAgeCategories[index - 1].title) !== 0 &&
            getAgeNumber(sortedAgeCategories[index + 1].title) !== 0
          hideAbbr = sortedAgeCategories[index + 2] && getAgeNumber(sortedAgeCategories[index + 2].title) !== 0
        }
      }

      return !hideTitle
        ? `${o.title}${sortedAgeCategories.length - 1 === index ? '' : ` ${t('PROPERTYBLOCK__AND')} `}`
        : !hideAbbr
        ? ` ${t('PROPERTYBLOCK__UPTO')} `
        : ''
    })

    const labelsString = labelsArray
      .join('')
      .replace(` ${t('PROPERTYBLOCK__AND')}  ${t('PROPERTYBLOCK__UPTO')} `, ` ${t('PROPERTYBLOCK__AND')} `)
    data.push({ icon: 'tag', label: labelsString })
  }

  if (durationEntryType?.exerciseDuration) {
    const exerciseDuration =
      customDuration && customDuration !== durationEntryType?.exerciseDuration
        ? customDuration
        : durationEntryType?.exerciseDuration
    data.push({
      icon: 'duration',
      label: `${exerciseDuration} ${t('DATE_MINUTE_ABBR')}`
    })
  }

  if (frequencyEntryType?.frequencyCount) {
    data.push({
      icon: 'date',
      label: frequencyEntryType.frequencyCount
    })
  }

  return data
}
